<template>
  <PButton
    class="flex items-center justify-center rounded-full"
    :disabled="is_disabled || null"
    variant="outlined"
    :severity="primary_color ? 'primary' : 'secondary'"
    :class="{ 'bg-white!': bg_white, 'self-stretch': self_stretch }"
    :size="size"
    @click.stop="submit"
  >
    <slot name="icon-left" />
    <div
      v-if="icon_name"
      class="icon flex items-center justify-center"
    >
      <AppIcon :name="icon_name" />
    </div>
    <div v-if="!hide_text">
      <slot>{{ $t('button.actions.cancel') }}</slot>
    </div>
    <Badge
      v-if="badge_count"
      data-test="notifications-number"
      :value="badge_count"
    />
    <slot name="icon-right" />
  </PButton>
</template>

<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { BUTTON_TERTIARY_ACTIONS_TO_ICON } from '@/app/data/button_constants';

const props = defineProps({
  badge_count: { type: Number, default: null },
  is_disabled: { type: Boolean },
  action: {
    type: String,
    default: null,
    validator: (prop) => Object.keys(BUTTON_TERTIARY_ACTIONS_TO_ICON).includes(prop),
  },
  size: { type: String, default: 'small' },
  to: { type: Object, default: null },
  hide_text: { type: Boolean },
  bg_white: { type: Boolean },
  self_stretch: { type: Boolean },
  primary_color: { type: Boolean },
});

const emit = defineEmits(['onClick']);

const router = useRouter();

const icon_name = computed(() => BUTTON_TERTIARY_ACTIONS_TO_ICON[props.action]);

function submit(event) {
  if (props.is_disabled) return;
  if (props.to) {
    router.push(props.to);
  } else {
    emit('onClick', event);
  }
}
</script>
